import React from 'react';

interface ProjectOverviewActivityProps {
  onViewAll?: () => void;
}

export function ProjectOverviewActivity({ onViewAll }: ProjectOverviewActivityProps) {
  const activities = [
    { user: 'Nguyễn Văn An', action: 'Cập nhật tiến độ dự án: 45%', time: '15/05/2024 09:30', avatar: null },
    { user: 'Trần Minh Tuấn', action: 'Hoàn thành công việc: Trồng cây khu A', time: '14/05/2024 16:20', avatar: null },
    { user: 'Lê Hoàng Nam', action: 'Thêm mới tài liệu: Bản vẽ chi tiết hệ thống tưới', time: '14/05/2024 10:15', avatar: null },
    { user: 'Phạm Văn Tài', action: 'Tạo công việc: Lắp đặt hệ thống chiếu sáng', time: '13/05/2024 14:45', avatar: null },
    { user: 'Hệ thống', action: 'Thanh toán đợt 2: 4.200.000.000 VND', time: '10/05/2024 11:00', icon: 'ri-money-dollar-circle-line' },
  ];

  return (
    <section className="h-full rounded-md bg-white p-4  border border-slate-100 flex flex-col gap-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900 tracking-wider">Nhật ký hoạt động</h3>
        <button 
          onClick={onViewAll}
          className="text-xs lg:text-sm font-normal text-emerald-600 hover:underline"
        >
          Xem tất cả
        </button>
      </div>

      <div className="flex-1 space-y-6 overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-slate-200">
        {activities.map((item, i) => (
          <div key={i} className="flex gap-3 relative group">
            {i !== activities.length - 1 && (
              <div className="absolute left-5 top-10 bottom-[-24px] w-px bg-slate-100" />
            )}
            
            <div className="relative z-10 w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center shrink-0 border border-white  group-hover:border-emerald-200 transition-all">
              {item.icon ? (
                <i className={`${item.icon} text-emerald-600`} />
              ) : (
                <span className="text-xs font-normal text-slate-500">{item.user.charAt(0)}</span>
              )}
            </div>

            <div className="flex flex-col gap-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-xs lg:text-sm font-normal text-slate-900">{item.user}</span>
                <span className="text-xs font-normal text-slate-400">{item.time}</span>
              </div>
              <p className="text-xs lg:text-sm font-normal text-slate-600 leading-snug line-clamp-2">
                {item.action}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
